import axios from 'axios';
import cookie from '../../cookieHelper/cookie'; // Assuming you have a cookie helper

export default function deleteStory(companyId) {
    const API_URL = `${process.env.REACT_APP_BASE_URL}/api/v1/user/delete/${companyId}`;

    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    return axios
        .post(API_URL, null, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        })
        .then(res => {
            // console.log("Response from delete: ", res);
            return res;
        })
        .catch(err => {
            // console.error("Error in delete: ", err);
            return err;
        });
}
